'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation requesting microphone access with blinking waves.
 */
export function MicrophonePermissionAnimation(props: IAnimationProps) {
  const loadAnimation = () => import('../raw-json/microphone-access.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="MicrophonePermissionAnimation"
    />
  );
}
